import { PageHeader } from "@/components/site/PageHeader";
import { BusinessSection } from "@/components/sections/BusinessSection";
import { IMAGES } from "@/lib/content";

export default function Business() {
  return (
    <>
      <PageHeader label="The Business Journey" title="FROM HOBBY TO BUSINESS?" image={IMAGES.fishFocus}>
        The honest question behind the whole project: can a tropical fish hobby actually become a sustainable
        business? This is where we try to find out.
      </PageHeader>
      <BusinessSection />
    </>
  );
}
